module.exports = __webpack_public_path__ + "img/mongodb.60605a1a.png";